import logo from '../assets/img/404.png'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

type Props = {}

const PageNotFound = (props: Props) => {
  const navigate = useNavigate()
  const handleRedirect = () => {
    navigate('/', { replace: true })
  }

  return (
    <Box
      width="100%"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#deeffc',
        minHeight: '500px',
        height: 'calc(100vh - 70px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '900px',
          width: '100%',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            style={{
              color: '#314469',
              marginBottom: '-15px',
              fontFamily: 'DMSansBold',
              fontSize: 'clamp(3rem, 8vw, 8em)', // responsive font
            }}
          >
            404
          </Typography>
          <Typography
            style={{
              color: '#314469',
              marginTop: '-40px',
              fontFamily: 'DMSansRegular',
              fontSize: 'clamp(1rem, 3vw, 1.5rem)',
            }}
          >
            PAGE NOT FOUND
          </Typography>
        </Box>

        <img
          src={logo}
          alt="404 Error"
          style={{
            maxWidth: '100%',
            width: '60vh',
            height: 'auto',
            margin: '1rem 0',
          }}
        />

        <Box
          sx={{
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            paddingX: 1,
          }}
        >
          <Typography
            variant="h1"
            style={{
              color: '#314469',
              fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
              fontFamily: 'DMSansBold',
            }}
          >
            Oops!
          </Typography>
          <Typography
            style={{
              color: '#314469',
              fontSize: 'clamp(0.9rem, 2.5vw, 1.2rem)',
              textAlign: 'center',
              maxWidth: '500px',
              fontFamily: 'DMSansRegular',
            }}
          >
            We couldn't find the page you were looking for
          </Typography>

          <Box
            onClick={handleRedirect}
            sx={{
              backgroundColor: '#314469',
              padding: '10px 20px',
              borderRadius: '5px',
              color: '#fff !important',
              textDecoration: 'none',
              fontFamily: 'DMSansBold',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              mt: 5,
            }}
          >
            <ArrowBackIosIcon style={{ fontSize: 16, marginTop: -1 }} />
            <Typography>Go Home</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PageNotFound
